/**
 * This just wraps chartjs-chart-matrix so it can be used as a Vue component.
 * Code is based on the Vue components from vue-chartjs.
 * https://github.com/kurkle/chartjs-chart-matrix
 */

import { generateChart } from 'vue-chartjs'
import { MatrixController } from 'chartjs-chart-matrix'

const Matrix = generateChart('matrix-chart', 'matrix', MatrixController);

export default Matrix
